


















import { Vue, Component, Prop, Emit } from "vue-property-decorator"

@Component
export default class Base64Uploader extends Vue {
  @Prop({ default: "アイキャッチ" })
  private label!: string

  public filename = ""

  @Emit("loadImage")
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public loadImage(image: string, fliename: string): void {
    /* nop */
  }

  public pickFile(): void {
    const element = this.$refs.image as InstanceType<typeof HTMLInputElement>
    element.click()
  }

  public onFilePicked(e: Event): void {
    const files = (e.target as HTMLInputElement).files
    if (files != null && files.length > 0) {
      const file = files[0]
      this.filename = file.name
      if (file.name && file.name.lastIndexOf(".") <= 0) {
        return
      }
      const reader = new FileReader()
      reader.onload = (event) => {
        if (event !== null) {
          this.loadImage(
            (event.target as FileReader).result as string,
            this.filename
          )
          // 後始末 (https://forum.vuejs.org/t/reset-input-type-file-using-vue-js/23524/8)
          const image = this.$refs.image as InstanceType<
            typeof HTMLInputElement
          >
          image.value = ""
        }
      }
      reader.readAsDataURL(file)
    } else {
      this.filename = ""
    }
  }
}
